import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { FiMail, FiLock, FiLogIn } from 'react-icons/fi';
import AuthShell from '../components/auth/AuthShell';

function OwnerLogin() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const result = await login(email, password, 'owner');
    
    if (result.success) {
      navigate('/owner/dashboard');
    } else {
      setError(result.error);
    }
    
    setLoading(false);
  };

  return (
    <AuthShell
      title="ElyDine"
      subtitle="Owner Console"
      quote="Clarity in data. Confidence in decisions. Consistency in growth."
    >
      <div className="text-center mb-8">
        <h2 className="text-3xl font-bold text-white tracking-tight">Owner Login</h2>
        <p className="text-sm text-gray-300 mt-2">Sign in with your owner credentials</p>
      </div>

      <form onSubmit={handleSubmit} className="space-y-6">
        {error && (
          <div className="p-4 bg-gray-800 border-2 border-red-500 rounded-lg text-sm text-white">
            {error}
          </div>
        )}

        <div>
          <label className="block text-sm font-semibold text-white uppercase tracking-wide mb-2">
            Email Address
          </label>
          <div className="relative">
            <FiMail className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full h-14 pl-10 pr-4 border-2 border-gray-700 rounded-lg bg-gray-800 text-white placeholder:text-gray-400 focus:outline-none focus:border-white focus:ring-0"
              placeholder="owner@elydine.com"
              required
            />
          </div>
        </div>

        <div>
          <label className="block text-sm font-semibold text-white uppercase tracking-wide mb-2">
            Password
          </label>
          <div className="relative">
            <FiLock className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full h-14 pl-10 pr-4 border-2 border-gray-700 rounded-lg bg-gray-800 text-white placeholder:text-gray-400 focus:outline-none focus:border-white focus:ring-0"
              placeholder="Enter your password"
              required
            />
          </div>
        </div>

        <button
          type="submit"
          disabled={loading}
          className="w-full h-14 bg-white hover:bg-gray-100 text-gray-900 font-semibold text-base transition-all duration-200 rounded-lg shadow-lg hover:shadow-xl active:scale-[0.98] flex items-center justify-center gap-2 disabled:opacity-50"
        >
          {loading ? (
            'Signing in...'
          ) : (
            <>
              <FiLogIn /> Sign In
            </>
          )}
        </button>
      </form>
    </AuthShell>
  );
}

export default OwnerLogin;
